import React, { Fragment } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Grid, Typography } from "@mui/material";
import theme from "../../theme";
import CommonFormField from "../../common/components/CommonFormField";
import CommonSelect from "../../common/components/CommonSelect";
import { LearningStyles } from "../../common/const";

const LearningStyle = ({
    formData,
    handleInputChange,
    errors
}) => {
    return (
        <CommonCard
            paddingBottom="0px"
            border={`1px solid #0000001A`}
            borderRadius={2}
            padding="0px"
            background="#CDD2F9"
            headerContent={
                <Fragment>
                    <Box p={2}>
                        <Typography fontWeight={600} fontSize={18}>Learning Style & Support Needs</Typography>
                        <Typography fontSize={14} color={theme.palette.background.dark}>Add your Learning Style & Support Needs</Typography>
                    </Box>
                    <Divider />
                </Fragment>
            }
            content={
                <Grid container spacing={2} p={2}>
                    <Grid item md={12}>
                        <CommonSelect
                            label="Preferred Learning Style"
                            name="learningStyle"
                            value={formData.learningStyle}
                            onChange={handleInputChange}
                            placeholder="Select style"
                            options={LearningStyles}
                            error={errors.learningStyle}
                        />
                    </Grid>
                    <Grid item md={12}>
                        <CommonFormField
                            label="Learning Accommodations Needed"
                            type="email"
                            name="learningNeed"
                            value={formData.learningNeed}
                            onChange={handleInputChange}
                            placeholder="Describe here"
                            error={errors.learningNeed}
                            multiline
                        />
                    </Grid>
                </Grid>
            }
        />
    )
}

export default LearningStyle;